import { defineComponent as _defineComponent } from 'vue'
import { nextTick, onMounted, ref, shallowRef, unref, watch } from 'vue';

import { useJqueryEventListener } from '#public_ts/composables';


export default /*#__PURE__*/_defineComponent({
  __name: 'bootstrap-button-dropdown',
  props: {
    icon: null,
    label: { type: [String, Boolean] },
    title: null,
    buttonClass: null,
    showDropdown: { type: Boolean },
    freezeDropdown: { type: Boolean }
  },
  emits: ["update:showDropdown", "dropdown-opened", "dropdown-closed"],
  setup(__props: any, { emit }: { emit: ({
    (event: 'update:showDropdown', value: boolean | undefined): void;
    (event: 'dropdown-opened', value: undefined): void;
    (event: 'dropdown-closed', value: undefined): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
    icon?: string;
    label?: string | boolean;
    title?: string;
    buttonClass?: string;
    showDropdown?: boolean;
    freezeDropdown?: boolean;
}


//eslint-disable-next-line no-spaced-func


const showDropdownRef = ref<boolean>(false);
const transition = ref(false);
const dropdownElement = shallowRef<HTMLElement | undefined>();
const dropdownToggle = shallowRef<HTMLElement | undefined>();

function waitCurrentTransition() {
    return new Promise((resolve) => {
        if(!unref(transition)) {
            resolve(undefined);
            return;
        }
        const _unwatch = watch(transition, () => {
            // multi-entry support, transition may be modified by other waiter
            // then we wait another transition
            if(unref(transition)) return;
            _unwatch();
            resolve(undefined);
        });
    });
}

function updateShowDropdown(_showDropdown: boolean | undefined) {
    const _showDropdown0 = !!_showDropdown;
    const _dropdownElement = unref(dropdownElement);
    const _dropdownToggle = unref(dropdownToggle);
    if(!_dropdownElement || !_dropdownToggle) return Promise.resolve();

    return Promise.resolve()
        .then(() => waitCurrentTransition())
        .then(() => {
            if(_showDropdown0 === unref(showDropdownRef)) return;
            if(checkProcessFrozen()) return;

            transition.value = true;
            showDropdownRef.value = _showDropdown0;
            $(_dropdownToggle).dropdown('toggle');
        });
}

function processDropdownToggle(_showDropdown: boolean | undefined) {
    const _showDropdown0 = !!_showDropdown;
    nextTick(() => {
        if(_showDropdown0 !== unref(showDropdownRef)) {
            // warning, properties not in sync, see updateShowModal
            showDropdownRef.value = _showDropdown0;
        }
        if(!!props.showDropdown !== _showDropdown0) {
            emit('update:showDropdown', _showDropdown0);
        }
        transition.value = false;
        if(_showDropdown0) {
            emit('dropdown-opened', undefined);
        } else {
            emit('dropdown-closed', undefined);
        }
    });
}

function checkProcessFrozen() {
    if(props.freezeDropdown) {
        const _showDropdown0 = !!unref(showDropdownRef);
        if(!!props.showDropdown !== _showDropdown0) {
            emit('update:showDropdown', _showDropdown0);
        }
        return true;
    }
    return false;
}

watch(() => props.showDropdown, (val, old) => {
    if(!!val !== !!old) {
        updateShowDropdown(val);
    }
});

onMounted(() => {
    //portal requires next tick
    nextTick(() => {
        if(props.showDropdown) {
            updateShowDropdown(true);
        }
    });
});

useJqueryEventListener(dropdownElement, 'show.bs.dropdown', (evt) => {
    if(evt && props.freezeDropdown) {
        evt.preventDefault();
        return false;
    }
    transition.value = true;
    return undefined;
});
useJqueryEventListener(dropdownElement, 'shown.bs.dropdown', () => {
    processDropdownToggle(true);
});
useJqueryEventListener(dropdownElement, 'hide.bs.dropdown', (evt) => {
    if(evt && props.freezeDropdown) {
        evt.preventDefault();
        return false;
    }
    transition.value = true;
    return undefined;
});
useJqueryEventListener(dropdownElement, 'hidden.bs.dropdown', () => {
    processDropdownToggle(false);
});

return { __sfc: true,props, emit, showDropdownRef, transition, dropdownElement, dropdownToggle, waitCurrentTransition, updateShowDropdown, processDropdownToggle, checkProcessFrozen }
}

})